// extracted by mini-css-extract-plugin
export default {"root":"hSZsuG","menuButton":"MHuRVq","iconBox":"k9M4X3","popoverRoot":"C_pOuZ","listItem":"KpRFyx","listItemIconWrapper":"pQ2Xsx"};